import { live, LiveController } from "@camertron/live-component";

@live("Flash")
export class Flash extends LiveController {
  close() {
    this.element.remove();
  }
}
